export default __webpack_public_path__ + "static/media/csod-green-checkmark.67c3bb74.svg";